var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-add-ons-carousel-wrapper" },
    [
      _c("carousel", {
        key: "add-ons-carousel-" + _vm.addOnsList.length,
        attrs: { selector: ".carousel-wrapper", variant: "booking-add-ons" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var imageLoadedEvent = ref.imageLoadedEvent
              var canLoad = ref.canLoad
              return _c(
                "section",
                { staticClass: "carousel component booking-add-ons-carousel" },
                [
                  _c(
                    "div",
                    { staticClass: "carousel-wrapper" },
                    _vm._l(_vm.addOnsList, function (addOn, index) {
                      return _c("BookingAddOnsSlide", {
                        key: "addOn-" + index,
                        attrs: {
                          "add-on": addOn,
                          "image-loaded-event": imageLoadedEvent,
                          "can-load": canLoad,
                        },
                        on: {
                          "select-add-on": function ($event) {
                            return _vm.$emit("select-add-on", $event)
                          },
                          "remove-add-on": function ($event) {
                            return _vm.removeAddOn($event)
                          },
                          "edit-add-on": function ($event) {
                            return _vm.$emit("edit-add-on", $event)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ]
              )
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        ref: "addonCancelModal",
        staticClass: "modify-modal modify-modal__cancel",
        attrs: {
          value: _vm.isOpen,
          variant: "default",
          "no-footer": "",
          "aria-labelled-by": "modify-cancel-modal-title",
        },
        on: { input: _vm.handleOpenModal, close: _vm.handleCloseModal },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "title",
                    attrs: { id: "modify-cancel-modal-title" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.ModifyReservationAddOnsCancelPopupTitle) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function (ref) {
              return [
                _c("div", { staticClass: "modify-modal__cancel-fees" }, [
                  _c("span", { staticClass: "cancel-icon" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.ModifyReservationAddOnsCancelPopupFeesMessage)
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "button-wrapper form-submit" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button--primary black size-md",
                      on: {
                        click: _vm.cancelAddOn,
                        keydown: [
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.cancelAddOn($event)
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.cancelAddOn($event)
                          },
                        ],
                      },
                    },
                    [_c("span", [_vm._v("Cancel")])]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }